export default "__VITE_ASSET__mQWfVFYA__"